import {StatusBadge} from 'ch3-ui-lib';
import {SettingsCard, SettingsGroup, SettingsLayout, SettingsPage} from './SettingsLayout';
import {SettingsRow} from './SettingsRow';
import {allAllowed, PermissionKind, PermissionValue, useBrowserPermission} from './browserPermissions';

const STATE_BADGE: Record<PermissionValue, { tone: 'success' | 'danger' | 'warning' | 'neutral'; label: string }> = {
    granted: {tone: 'success', label: 'Allowed'},
    denied: {tone: 'danger', label: 'Blocked'},
    prompt: {tone: 'warning', label: 'Not asked yet'},
    unsupported: {tone: 'neutral', label: 'Not supported'},
};

const PermissionRow = ({kind, title, description}: { kind: PermissionKind; title: string; description: string }) => {
    const {state, request} = useBrowserPermission(kind);
    return (
        <SettingsRow
            title={title}
            description={state === 'denied' ? 'Blocked in this browser. Allow it in the site settings next to the address bar.' : description}
            trailing={state && (
                <div className="flex items-center gap-2">
                    {state === 'prompt' && (
                        <button type="button" onClick={request} className="h-control-sm cursor-pointer rounded-control bg-brand px-3 text-footnote font-medium text-white hover:bg-brand-hover">
                            Allow
                        </button>
                    )}
                    <StatusBadge tone={STATE_BADGE[state].tone} className="!h-[22px] !text-caption">{STATE_BADGE[state].label}</StatusBadge>
                </div>
            )}
        />
    );
};

const PermissionsSettings = () => {
    const microphone = useBrowserPermission('microphone');
    const notifications = useBrowserPermission('notifications');
    const ok = allAllowed(microphone.state, notifications.state);

    return (
        <SettingsLayout title="Permissions">
            <SettingsPage>
                <SettingsGroup
                    title="Browser permissions"
                    description={ok ? 'Everything calls need is allowed in this browser.' : 'Calls need these to work in this browser.'}
                >
                    <SettingsCard>
                        <PermissionRow kind="microphone" title="Microphone" description="Without it the other side hears nothing"/>
                        <PermissionRow kind="notifications" title="Notifications" description="Needed to show an incoming call"/>
                    </SettingsCard>
                </SettingsGroup>
            </SettingsPage>
        </SettingsLayout>
    );
};

export default PermissionsSettings;
